import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { deleteCommunityApi, getCommunityApi } from "../../services/community";
import toast from "react-hot-toast";
import NotFound from "../../components/not-found/NotFound";
import { RiCommunityLine } from "react-icons/ri";
import { IconButton } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import {
  DatePicker,
  Select,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { Button, SecondaryButton } from "../../components/Button/Button";
import ModalBox from "../../components/modal/ModalBox";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ChangeCommunityStatus from "./ChangeCommunityStatus";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { DescriptionModal, ViewMore } from "../../comman/action/ViewMore";
import { ViewIcon } from "../../comman/action/ViewIcon";
import EditIcon from "../../comman/action/EditIcon";
import { PaginationShow } from "../../comman/action/Pagination";

const CommunityList = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";
  let createdBy = searchParam.get("createdBy") || "";

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);

  const [orderByMember, setOrderByMember] = useState("");
  const [orderByCreatedAt, setOrderByCreatedAt] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");

  const [description, setDescriptionModal] = useState(false);
  const [showDescriptionValue, setShowDescriptionValue] = useState("");

  const [communityList, setCommunityList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [communityName, setCommunityName] = useState("");
  const [statusId, setStatusId] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");

  //-------------handle-see-More-------------
  const handleSeeMore = (about) => {
    setShowDescriptionValue(about);
    setDescriptionModal(true);
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
    setCommunityName(name);
  };
  // //*********delete product********* */
  const deleteHandler = (id, name) => {
    setDeleteModal(true);
    setDeleteId(id);
    setDeleteName(name);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setDirection("");
    setFieldName("");
    setOrderByCreatedAt("");
    setOrderByMember("");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("status");
    searchParam.delete("createdBy");
    setSearchParam(searchParam);
  };
  //-----------search-createdAt-------------
  const handleCreated = (event) => {
    searchParam.set("createdBy", event.target.value);
    searchParam.set("page", 1);
    setSearchParam(searchParam);
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("startDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //--------------sorting-member------------------------
  const orderByMemberFun = () => {
    const newDirection = orderByMember === "ASC" ? "DESC" : "ASC";
    setOrderByMember(newDirection);
    setFieldName("totalMembers");
    setDirection(newDirection);
  };
  //--------------sorting-createdAt------------------------
  const orderByCreatedAtFun = () => {
    const newDirection = orderByCreatedAt === "ASC" ? "DESC" : "ASC";
    setOrderByCreatedAt(newDirection);
    setFieldName("createdAt");
    setDirection(newDirection);
  };
  //--------------delete-product------------------------
  const deleteProduct = async () => {
    try {
      const res = await deleteCommunityApi(deleteId);
      if (res?.data?.status === 200) {
        toast.success(res.data.message);
        setDeleteModal(false);
        fathCommunityList();
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  //------------------listing-Api----------------------------------
  const fathCommunityList = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction,
    createdAt = createdBy,
    startDate = searchStartDate,
    endDate = searchEndDate
  ) => {
    try {
      setCommunityList([]);
      showLoader();
      const res = await getCommunityApi({
        page,
        search,
        sortField,
        sortDirection,
        createdBy: createdAt,
        startDate,
        endDate,
      });
      if (res.data.status === 200) {
        setCommunityList(res?.data?.data?.Community || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setCommunityList([]);
        setTotal(0);
        hideLoader();
        toast.error(res?.data?.message);
      }
    } catch (e) {
      hideLoader();
      toast.error(e.message);
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!createdBy) {
      searchParam.delete("createdBy");
    }

    setSearchParam(searchParam);
    fathCommunityList(
      activePage,
      debounceValue,
      fieldName,
      direction,
      createdBy
    );
  }, [searchParam, debounceValue, fieldName, direction, createdBy]);

  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      fathCommunityList(
        activePage,
        debounceValue,
        fieldName,
        direction,
        searchStartDate,
        searchEndDate
      );
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    setSearchParam(searchParam);
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Community Circles</h4>
            <Button to={"/community-circles/create-community"}>
              Create Community
            </Button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="search"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* --------select-createdBy---------- */}
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  createdBy === "" ? "text-secondary" : "text-dark"
                }`}
                value={createdBy}
                onChange={handleCreated}
              >
                <option value="">Select Created By</option>
                <option value="admin">Admin</option>
                <option value="user">User</option>
              </Select>
            </div>
            <div className="form-group date_picker">
              <DatePicker
                className="form-control "
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
            </div>
            <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />
            </div>
            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Community Name</th>
                  <th>
                    <div className="sorting-th" onClick={orderByMemberFun}>
                      <span>Member</span>
                      {orderByMember === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="sorting-th" onClick={orderByCreatedAtFun}>
                      <span>Created At</span>
                      {orderByCreatedAt === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Created By</th>
                  <th>About & Purpose</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {communityList.length > 0 ? (
                  communityList.map(
                    (
                      {
                        _id,
                        about,
                        communityName,
                        createdAt,
                        status,
                        user,
                        createdBy,
                        totalMembers,
                      },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>
                              {" "}
                              <ViewMore
                                value={communityName}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>{`${totalMembers} Members` || "N/A"}</td>
                            <td>{dateFormat(createdAt)}</td>
                            <td>{createdBy === "user" ? user : "Admin"}</td>
                            <td>
                              <ViewMore
                                value={about}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <Switch
                                  checked={status}
                                  onChange={() =>
                                    statusUpdateHandler(
                                      _id,
                                      status,
                                      communityName
                                    )
                                  }
                                />
                                <EditIcon
                                  to={`/community-circles/update-community/${_id}`}
                                />

                                <ViewIcon
                                  to={`/community-circles/view-details/${_id}`}
                                />

                                <IconButton
                                  onClick={() =>
                                    deleteHandler(_id, communityName)
                                  }
                                >
                                  <DeleteForeverIcon
                                    sx={{ color: "red", fontSize: 26 }}
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Community Found!"
                    icon={<RiCommunityLine style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
        <ChangeCommunityStatus
          show={statusModal}
          close={() => setStatusModal(false)}
          id={statusId}
          status={statusValue}
          listing={fathCommunityList}
          name={communityName}
        />
        {/* --------delete-product-modal---------- */}
        <ModalBox
          status={deleteModal}
          onClose={() => setDeleteModal(false)}
          title="Delete Community"
          description={
            <span>
              Do you want to delete <strong>{deleteName}</strong>?
            </span>
          }
          // description="Do you want to delete this community?"
          action={deleteProduct}
        />
        {/* --------show-product-modal-description-if-large---------- */}
        <DescriptionModal
          show={description}
          close={() => setDescriptionModal(false)}
          title="About & Purpose"
          value={showDescriptionValue}
        />
      </div>
    </>
  );
};

export default CommunityList;
